import { render, staticRenderFns } from "./CancelOwnerRequest.vue?vue&type=template&id=4135f03a&scoped=true"
import script from "./CancelOwnerRequest.vue?vue&type=script&lang=js"
export * from "./CancelOwnerRequest.vue?vue&type=script&lang=js"
import style0 from "./CancelOwnerRequest.vue?vue&type=style&index=0&id=4135f03a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4135f03a",
  null
  
)

export default component.exports